import { ScaleLinear, ScaleTime } from 'd3-scale';

import { LinePath } from '@visx/shape';
import { curveMonotoneX } from '@visx/curve';
import { Group } from '@visx/group';

import { hasNoNeighbors } from './utils';

type LineSeriesProps = {
  data: { date: Date; value: number | null }[];
  strokeColor: string;
  strokeOpacity?: number;
  valueScale: ScaleLinear<number, number>;
  dateScale: ScaleTime<number, number>;
};

export const LineSeries = (props: LineSeriesProps) => {
  const { data, strokeColor, strokeOpacity = 1, valueScale, dateScale } = props;

  return (
    <Group>
      <LinePath
        data={data}
        x={({ date }) => dateScale(date) ?? 0}
        y={({ value }) => valueScale(value ?? 0)}
        defined={({ value }) => value !== null}
        stroke={strokeColor}
        strokeOpacity={strokeOpacity}
        curve={curveMonotoneX}
      />
      {data
        .filter((_, i) => hasNoNeighbors(data, i))
        .map(({ date, value }) => {
          if (value === null) {
            return null;
          }
          return (
            <circle
              key={`dot-${date.toISOString()}`}
              cx={dateScale(date)}
              cy={valueScale(value)}
              r={1.5}
              fill={strokeColor}
            />
          );
        })}
    </Group>
  );
};
